import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EstateAdminVM } from 'src/app/view-company/service/view-models/employee.view-model';

@Component({
  selector: 'app-employee-estates',
  templateUrl: './employee-estates.component.html',
  styleUrls: ['./employee-estates.component.scss']
})
export class EmployeeEstatesComponent implements OnInit {
  @Input() adminVMs: EstateAdminVM[] = [];
  @Input() sliceLength: number = 4;
  @Input() color: 'primary' | 'green' = 'primary';
  @Input() canDelete = true;
  @Input() showCompany = false;

  @Output() onDelete = new EventEmitter<EstateAdminVM>();

  constructor() {}

  ngOnInit(): void {}
}
